import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import toast from 'react-hot-toast';
import PublicHeader from '../components/PublicHeader';
import PublicFooter from '../components/PublicFooter';
import PasswordInput from '../components/ui/PasswordInput';

export default function LoginPage() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success('Connexion réussie');
      navigate('/');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Identifiants invalides');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      <PublicHeader />
      <main id="main-content" className="flex-1 flex items-center justify-center pt-16 p-4" tabIndex={-1}>
        <div className="w-full max-w-md">
          <div className="bg-white rounded-xl shadow-lg p-8">
          <h1 className="text-2xl font-bold text-slate-800 mb-2 text-center">Connexion</h1>
          <p className="text-slate-500 text-sm text-center mb-6">
            Accédez à votre espace Baromètre
          </p>
          <form onSubmit={handleSubmit} className="space-y-4" aria-label="Formulaire de connexion">
            <div>
              <label htmlFor="login-email" className="block text-sm font-medium text-slate-700 mb-1">Email</label>
              <input
                id="login-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
                aria-required="true"
                className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent min-h-[44px]"
                placeholder="votre@email.com"
              />
            </div>
            <PasswordInput
              id="login-password"
              label="Mot de passe"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
              aria-required="true"
              placeholder="••••••••"
            />
            <button
              type="submit"
              disabled={loading}
              aria-busy={loading}
              className="w-full py-2 px-4 min-h-[44px] bg-primary-600 text-white font-medium rounded-lg hover:bg-primary-700 disabled:opacity-50 focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
            >
              {loading ? 'Connexion...' : 'Se connecter'}
            </button>
          </form>
          <p className="mt-6 text-sm text-center text-slate-500">
            <Link to="/forgot-password" className="text-primary-600 hover:underline block mb-2">
              Mot de passe oublié ?
            </Link>
            Pas encore de compte ?{' '}
            <Link to="/register" className="text-primary-600 hover:underline">
              S&apos;inscrire
            </Link>
          </p>
          <p className="mt-2 text-sm text-center text-slate-500">
            <Link to="/admin/login" className="text-slate-500 hover:text-slate-700">
              Accès administrateur
            </Link>
          </p>
          </div>
        </div>
      </main>
      <PublicFooter />
    </div>
  );
}
